<template>
    <div class="ConditionsForm">
        <div class="condition-item" v-for="(condition, index) in conditionList" :key="index">
            <div class="centerY" v-if="condition.variable || condition.value">
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="condition.variable"
                        :placeholder="$f.tc('enterVariable')"
                        class="input-custom"
                        :readonly="readonly"
                    ></v-text-field>
                </div>
                <div style="width: 45px" class="mr-6 operator">
                    <v-select
                        dense
                        :items="OperatorList"
                        v-model="condition.operator"
                        class="input-custom"
                        :readonly="readonly"
                    ></v-select>
                </div>
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="condition.value"
                        :placeholder="$f.tc('enterValue')"
                        class="input-custom"
                        :readonly="readonly"
                    ></v-text-field>
                </div>
                <div class="btn-icon" @click="deleteCondition(condition)" v-if="!readonly">
                    <img src="/img/delete-blue.svg" alt="icon-delete-condition" style="transform: scale(1.2)">
                </div>
            </div>
        </div>
        <div v-if="!readonly && value" style="font-size: 14px; color: #96add0">
            {{$f.tc('noDataAvailable')}}
        </div>
        <div v-if="!readonly">
            <div class="centerY">
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="newCondition.variable"
                        :placeholder="$f.tc('enterVariable')"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div style="width: 45px" class="mr-6 operator">
                    <v-select
                        :items="OperatorList"
                        v-model="newCondition.operator"
                        class="input-custom"
                        dense
                    ></v-select>
                </div>
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="newCondition.value"
                        :placeholder="$f.tc('enterValue')"
                        @keypress.enter="addCondition"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div class="btn-icon" @click="addCondition">
                    <img src="/img/add-blue.svg" alt="icon-add-condition" style="transform: scale(1.3)">
                </div>
            </div>
            <div v-if="message" class="mt-6" style="color: red; font-size: 13px; font-family: 'open sans'">
                {{message}}
            </div>
        </div>
    </div>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import lodash from 'lodash'

const {OperatorList} = ScenarioService

export default {
    name: "ConditionsForm",
    props: {
        value: Array,
        readonly: Boolean
    },
    data() {
        return {
            OperatorList,
            conditionList: [],
            newCondition: {
                variable: '',
                operator: '=',
                value: ''
            },
            message: ''
        }
    },
    mounted() {
        this.conditionList = this.value
    },
    methods: {
        addCondition () {
            if (!this.newCondition.variable || !this.newCondition.value) {
                this.message = this.$f.tc('pleaseEnterAllFields')
                return
            }
            this.message = ''
            this.conditionList.push(this.newCondition)
            this.newCondition = {
                variable: '',
                operator: '=',
                value: ''
            }
        },
        deleteCondition (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('condition') })).then(
                () => {
                    let idx = this.conditionList.findIndex(i => lodash.isEqual(i, item))
                    if (idx > -1) {
                        this.conditionList.splice(idx, 1)
                        this.$forceUpdate()
                    }
                }
            )
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function () {
                this.conditionList = this.value
            }
        },
        conditionList: {
            deep: true,
            handler: function () {
                this.$emit('input', this.conditionList)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ConditionsForm {
    .condition-item {
        margin-bottom: 6px;
        &:last-child {
            margin-bottom: 0 !important;
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            font-family: "open sans" !important;
            font-size: 14px !important;
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.operator {
    ::v-deep .v-select.v-text-field input {
        display: none !important;
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field .v-input__append-inner {
        display: none;
    }

    .v-select__selection--comma {
        margin: 0 !important;
    }

    .v-select__selections {
        justify-content: center;
    }

    .v-text-field__details {
        display: none;
    }
}
</style>
